module.exports = __webpack_public_path__ + "static/media/icon-plus.aecaa377.svg";